<template>
  <section class="layout">
    <div
      class="overflow-x-hidden overflow-y-auto fixed inset-0 z-30 outline-none focus:outline-none justify-center items-center flex"
      v-if="value"
    >
      <div class="relative mx-auto my-4 w-25">
        <div
          class="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none"
        >
          <button
            class="ml-auto bg-transparent border-0 text-black opacity-5 flex text-2xl leading-none outline-none focus:outline-none"
            @click.prevent="close"
          >
            <img
              :src="require(`@/assets/svg/X.svg`)"
              alt="Cross"
              class="focus:outline-none pt-4 pr-4"
            />
          </button>
          <div
            class="flex items-center justify-center text-2xl leading-8 tracking-tight font-semibold"
          >
            {{ title }}
          </div>

          <!--body-->
          <div
            class="relative flex-auto text-left"
            :class="[hideModalHeader ? 'p-5' : 'py-5 px-10']"
          >
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
    <div v-if="value" class="opacity-75 fixed inset-0 z-20 bg-gray-500"></div>
  </section>
</template>

<script>
export default {
  name: "NewModal",
  props: {
    value: {
      required: true,
    },
    title: {
      type: String,
    },
    handleClose: {
      type: Function,
    },
    hideModalHeader: {
      type: Boolean,
      default: false,
    },
    classStr: {
      type: String,
    },
    headerClass: {
      type: String,
    },
    whiteCross: {
      type: String,
    },
  },
  methods: {
    close() {
      if (this.handleClose) {
        this.handleClose(!this.value);
      } else {
        this.$emit("input", !this.value);
      }
    },
  },
};
</script>

<style scoped>
.w-25 {
  width: 404px;
}
</style>
